import React from "react";
import { NavLink } from "react-router-dom";
import { FaFacebook, FaInstagram, FaTwitter, FaWhatsapp, FaYoutube } from 'react-icons/fa';

const baseURL = process.env.PUBLIC_URL + '/assets/';

const Footer = () => (
  <div className="">
    <div className="bg-footer-blue-custom flex flex-col px-5 pt-5 pb-2  max-md:mt-10 max-md:px-0 w-full">
      <div className="flex flex-col sm:flex-row justify-center gap-2 ml-2 sm:ml-20 items-start max-md:max-w-full max-md:flex-wrap max-md:mr-0 max-md:ml-10">
        <LinkSection
          title="Useful Links"
          links={["Contact Us", "Transfer Certificate", "Mandatory Public Disclosure", "Gallery", "Infrastructure"]}
          className="flex-1 sm:flex-1"
        />

        <ContactInfo className="mt-5 sm:mt-0 flex-1 sm:flex-1" />

        <SocialSection className="mt-5 sm:mt-0 flex-1 sm:flex-1" />
      </div>
      <FooterContent />
    </div>
  </div>
);

const FooterContent = () => (
  <div className="text-white text-center text-xs tracking-wide ml-1 mr-1 mt-2  max-md:max-w-full max-md:mr-0 max-md:mt-8">
    © 2022 - 2026, Motherland Children Academy, Affiliated to CBSE. All Rights Reserved.
    <br />
    Website Designed & Developed By Aadesh Gupta & <a href="https://www.linkedin.com/in/sparsh-dusad-13b0b3170" class="underline hover:text-blue-600" target="_blank" rel="noopener noreferrer">Sparsh Dusad</a>
  </div>
);

const LinkSection = ({ title, links, className }) => (
  <div className={`flex flex-col items-stretch text-base text-stone-300 font-medium text-justify ${className}`}>
    <SectionHeader title={title} />
    <div className="mt-2">
      {links.map((link, index) => (
        <LinkItem key={index} link={link} />
      ))}
    </div>
  </div>
);

const SectionHeader = ({ title }) => (
  <div className="text-amber-400 text-lg font-bold tracking-wider uppercase">
    {title}
  </div>
);

const LinkItem = ({ link }) => {
  const links = {
    "Contact Us": "/ContactUsPage",
    "Transfer Certificate": "/TCPage" ,
    "Mandatory Public Disclosure": "/mpd",
      "Gallery" : "/GalleryPage",
      "Infrastructure" :"/InfraPage",
  };

  return (
    <div className="whitespace-nowrap mt-1">
      <NavLink to={links[link]} className="text-white hover:underline text-sm">
        {link}
      </NavLink>
    </div>
  );
};

const ContactInfo = () => (
  <div className={`self-stretch flex flex-col flex-1 mb-4 max-md:mb-0 `}>
     <div className="flex flex-col">
      <div className="text-xl font-bold tracking-wide text-justify text-amber-400 uppercase">
        Contact us
      </div>
      <div className="flex gap-5 justify-between mt-4 tracking-wide">
        <div className="flex flex-col self-start text-justify text-stone-300">
          <div className="text-sm">Email Id:</div>
          <div className="mt-3 text-sm">Phone:</div>
          <div className="mt-3 text-sm">Tel No:</div>
          <div className="mt-3 text-sm">Location:</div>
        </div>
        <div className="flex flex-col text-zinc-100">
          <div className="text-justify text-sm">mcatonk@gmail.com</div>
          <div className="mt-3 text-justify text-sm">‪8239945863, 8209549018, 6376147129‬</div>
          <div className="mt-3 text-sm">01432-244097</div>
          <a href="https://maps.app.goo.gl/XVBWqLeWyKBWrKST9?g_st=iw" target="_blank">
          <div className="mt-3 text-justify text-sm underline">Punch Kuiya Darwaza, Purani Tonk, Tonk (Rajasthan), 304001</div>
          </a>
        </div>
      </div>
    </div>
  </div>
);



const ContactDetails = ({ label, info }) => (
  <div className="flex flex-row mt-1 gap-1 ">
    <p className= "text-sm text-slate-400">{label}:</p>
    <p className="text-white text-sm text-justify">{info}</p>
  </div>
);

const SocialSection = ({ className }) => (
  <div className={`flex flex-col items-stretch text-center text-base text-white font-medium ${className}  max-md:text-left`}>
    <SectionHeader title="Social"  />
    <div className="flex flex-col items-center gap-1 mt-2 max-md:flex-row max-md:gap-6">
      <SocialLink platform="Facebook" />
      <SocialLink platform="Twitter" />
      <SocialLink platform="Instagram" />
      <SocialLink platform="Youtube" />
    </div>
  </div>
);

const SocialLink = ({ platform }) => {
  const socialLinks = {
    Facebook: "https://www.facebook.com/share/1Eqw2eHiqk/?mibextid=wwXIfr",
    Twitter: "https://twitter.com/MOTHERLANDTONK",
    Instagram :"https://www.instagram.com/mca_tonk/" ,
    Youtube : "https://youtube.com/@motherlandchildrenacademy_tonk?si=nDGsElJqCjmfJ7PZ"
    // Add more social platforms and their respective links
  };

  const IconComponent = {
    Facebook: FaFacebook,
    Twitter: FaTwitter,
    Instagram : FaInstagram,
    Youtube : FaYoutube,
    // Add more social platforms and their respective icons
  }[platform];

  return (
    <div className="mt-4 max-md:mt-2 text-sm">
      <a href={socialLinks[platform]} target="_blank" rel="noopener noreferrer">
        <IconComponent size={24} className="text-white hover:text-amber-400 cursor-pointer" />
      </a>
    </div>
  );
};

export default Footer;
